//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const date = ref('2017-12')

    const allowedMonths = val => parseInt(val.split('-')[1], 10) % 2 === 0

    return {
      date,
      allowedMonths,
    }
  },
}
